import { ApiService } from 'services';

/* eslint-disable-next-line */
export function redirectToLogin() {
  const url = ApiService.getLoginUrl();

  if (url) {
    window.location = url;
  }
}
